import { render, staticRenderFns } from "./ManagementAudioLibrary.vue?vue&type=template&id=c9dfe946&scoped=true"
import script from "./ManagementAudioLibrary.vue?vue&type=script&lang=js"
export * from "./ManagementAudioLibrary.vue?vue&type=script&lang=js"
import style0 from "./ManagementAudioLibrary.vue?vue&type=style&index=0&id=c9dfe946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dfe946",
  null
  
)

export default component.exports